import {ThemeSettingsContext} from '../providers';
import {useContext} from 'react';

export const useThemeSettings = () => {
  const value = useContext(ThemeSettingsContext);

  if (value === null) {
    throw new Error(
      'Missing the ThemeSettingsProvider. Please make sure to add the KEITheme to your component heirarchy'
    );
  }

  return value;
};
